import { Logo } from '@/components/shared/Logo';
import { DesktopMenu } from './DesktopMenu';

export const LeftNav = () => {
  return (
    <div className="flex items-center justify-between gap-2 lg:gap-8 h-full">
      <div className="h-full py-1 pl-2 sm:pl-0" data-testid="main-logo-link">
        <Logo className="max-w-20 sm:max-w-24 h-full" />
      </div>
      <DesktopMenu />
    </div>
  );
};
